<template>
  <b-row align-h="center">
    <b-col sm="12" md="6" lg="4">
      <b-button variant="light" :to="{name: 'login'}"> &lt; Back to Login</b-button>
      <h2>Forgot Password</h2>
      <b-form @submit="onSubmit">
        <b-form-group label="Email address:">
          <b-form-input v-model="form.email" type="email" required placeholder="Email"/>
          <b-form-invalid-feedback
            v-if="formErrors && formErrors.email && formErrors.email.length > 0" :state="false">
            <p v-for="(e, $index) in formErrors.email" :key="$index">{{e}}</p>
          </b-form-invalid-feedback>
        </b-form-group>

        <b-button type="submit" variant="primary" :disabled="formLoading">
          Send an email
        </b-button>

      </b-form>
    </b-col>
  </b-row>
</template>

<script>
import formsMixin from '@/mixins/forms';

export default {
  mixins: [formsMixin],
  data() {
    return {
      storeDispatchTarget: 'AuthStore/forgotPassword',
      routerTarget: { name: 'login', params: { message: 'Password reset email successfully sent.' } },
      form: {
        email: '',
      },
      formErrors: {
        email: null,
      },
    };
  },
};
</script>
